import React, { FC, useRef } from 'react';
import styled from 'styled-components';

import { IconBase } from '@column/column-ui-kit';

interface InterestPayoutIconProps {
  className?: string;
}

const Wrapper = styled.div``;

export const InterestPayoutIcon: FC<InterestPayoutIconProps> = ({ className }) => {
  const wrapeprRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper ref={wrapeprRef} className={className}>
      <IconBase viewportSize={20}>
        <path d="M16 4L4 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle
          cx="13.9961"
          cy="13.998"
          r="2"
          transform="rotate(180 13.9961 13.998)"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M4 6.2981L6.29809 4L8.59619 6.2981"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconBase>
    </Wrapper>
  );
};
